import { render, staticRenderFns } from "./UnitView.vue?vue&type=template&id=0bc207e8&scoped=true&"
import script from "./UnitView.vue?vue&type=script&lang=ts&"
export * from "./UnitView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc207e8",
  null
  
)

export default component.exports